import BreadCrumb from 'src/feature/bite/component/Breadcrumb'
import Form from '../component/Edit'

import {useGetDetail} from '../context/useQuery'

export default function TerminalNew() {
  const {isLoading} = useGetDetail()

  return (
    <>
      <BreadCrumb parentPage='TPNs' currentPage='Edit TPN' />
      <div id='kt_app_content_container' className='d-flex flex-column flex-root mt-10'>
        <Form />
      </div>
    </>
  )
}
